import React, { useState, useEffect } from 'react';
import './PinPage.css';

const SERVER_URL = process.env.REACT_APP_SERVER_URL || window.location.origin;

export default function PinPage({ onUnlock }) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [pinRequired, setPinRequired] = useState(null);

  useEffect(() => {
    // Check if PIN is required
    fetch(`${SERVER_URL}/api/pin-required`)
      .then(r => r.json())
      .then(data => {
        if (!data.required) onUnlock(); // No PIN needed
        else setPinRequired(true);
      })
      .catch(() => onUnlock()); // If error, skip PIN
  }, []);

  async function handleSubmit() {
    if (!pin) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${SERVER_URL}/api/verify-pin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin }),
      });
      const data = await res.json();
      if (data.ok) {
        sessionStorage.setItem('sentinel-unlocked', '1');
        onUnlock();
      } else {
        setError('PIN incorrecto');
        setPin('');
      }
    } catch {
      setError('Error de conexión');
    }
    setLoading(false);
  }

  if (pinRequired === null) return null;

  return (
    <div className="pin-page">
      <div className="pin-bg" />
      <div className="pin-box">
        <div className="pin-logo">⬡</div>
        <div className="pin-title">SENTINEL</div>
        <div className="pin-subtitle">INTRODUCE TU PIN</div>

        <input
          type="password"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={8}
          className="pin-input"
          value={pin}
          onChange={e => setPin(e.target.value.replace(/\D/g, ''))}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          placeholder="••••"
          autoFocus
        />

        {error && <div className="pin-error">{error}</div>}

        <button className="pin-btn" onClick={handleSubmit} disabled={loading || !pin}>
          {loading ? 'VERIFICANDO...' : 'ACCEDER →'}
        </button>
      </div>
    </div>
  );
}
